import { useMemo } from "react";
import { useGameStore } from "@/store/gameStore";
import { enumerateLegalActions } from "@/engine/LegalActions";
import type { EngineAction } from "@/engine/GameEngine";

export function useLegalActions(): EngineAction[] {
  const state = useGameStore((s) => s.state);
  const humanId = useGameStore((s) => s.humanPlayerId);
  return useMemo(() => {
    if (!state) return [];
    return enumerateLegalActions(state, humanId);
  }, [state, humanId]);
}
